import { useEffect, useState } from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    Input,
    Pagination,
    PaginationItem,
    PaginationLink,
    Spinner,
    Table
} from "reactstrap";
import { UserDto } from "../types/User";
import UserService from "../Services/UserService";
import EditUserModal from "./EditUserModal";
import PermissionModal from "./PermissionModal";
import CreateUserModal from "./CreateUserModal";
import { Pen, ShieldBan, Trash2, UserRoundPlus, } from "lucide-react";
import DeleteuserModal from "./DeleteuserModal";
import UserStatisticCard from "./UserStatisticCard";
import "./UserManagement.css";
import { start } from "repl";


const UserManage = () => {

    const [users, setUsers] = useState<UserDto[]>([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);

    const itemPerpage = 15;



    const [createOpen, setCreateOpen] =
        useState(false);
    const [search, setSearch] = useState("");

    const [selectedUser, setSelectedUser] =
        useState<UserDto | null>(null);

    const [editOpen, setEditOpen] =
        useState(false);

    const [permissionOpen, setPermissionOpen] =
        useState(false);

    const [deleting, setDeleting] = useState(false);


    const [deteleuserOpen, setdeteleuserOpen] = useState(false);

    const openDelete = (user: UserDto) => {
        setSelectedUser(user);
        setdeteleuserOpen(true);
    };


    const formatTime = (date: string | null | undefined) => {
        if (!date) return "-";

        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "2-digit",
        }).format(new Date(date));
    };

    const formatDate = (date: string | null | undefined) => {
        if (!date) return "-";

        return new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).format(new Date(date));
    };

    const [role, setRole] = useState("");

    const handleRoleChange = (
        e: React.ChangeEvent<any>
    ) => {
        setRole(e.target.value);
    };

    const loadUsers = async () => {

        setLoading(true);

        try {

            const data =
                await UserService.getAll();

            setUsers(data);

        }
        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadUsers();

    }, []);

    const filteredUsers = users.filter((user) => {
        const matchesSearch =
            user.name.toLowerCase().includes(search.toLowerCase()) ||
            user.email.toLowerCase().includes(search.toLowerCase());

        const matchesRole =
            role === "" || user.role === role;

        return matchesSearch && matchesRole;
    });

    const deleteUser = async () => {
        if (!selectedUser) return;

        try {
            setDeleting(true);

            await UserService.delete(selectedUser.userID);

            setdeteleuserOpen(false);
            setSelectedUser(null);

            await loadUsers();
        } catch (error) {
            console.error(error);
        } finally {
            setDeleting(false);
        }
    };

    const totalPages = Math.ceil(filteredUsers.length / itemPerpage);

    const startIndex = (currentPage -1) * itemPerpage;

    const endIndex = startIndex + itemPerpage;

    const paginateduser = filteredUsers.slice(
        startIndex,
        endIndex
    );

    return (

        <Container fluid>
            <UserStatisticCard />

            <Card className="user-management-card">
    <CardHeader className="user-header">
        <h4 className="page-title">User Management</h4>

        <div className="header-actions">
            <Button
                color="success"
                onClick={() => setCreateOpen(true)}
            >
                <UserRoundPlus className="me-1" />
                Create User
            </Button>

            <Button
                color="primary"
                onClick={loadUsers}
            >
                Refresh
            </Button>
        </div>
    </CardHeader>

                <CardBody>
                  <div className="filter-container">

    <Input
        placeholder="Search users..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
    />

    <Input
        type="select"
        value={role}
        onChange={handleRoleChange}
    >
        <option value="">All Roles</option>
        <option value="SuperAdmin">Super Admin</option>
        <option value="Admin">Admin</option>
        <option value="Coordinator">Coordinator</option>
        <option value="Customer">Customer</option>
    </Input>

</div>



                    {
                        loading ?

                            <div className="text-center py-5">

                                <Spinner />

                            </div>

                            :
<div className="desktop-table">
                            <Table
                                bordered
                                hover
                                responsive
                            >

                                <thead>

                                    <tr>

                                        <th>Name</th>

                                        <th>Email</th>

                                        <th>Role</th>

                                        <th>Gender</th>

                                        <th>Phone No</th>

                                        <th>Created At</th>

                                        <th>Login At</th>

                                        <th>Status</th>

                                        <th style={{ width: "250" }}>
                                            Actions
                                        </th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {
                                        paginateduser.map(user => (

                                            <tr key={user.userID}>

                                                <td className="action-column">
                                                    {user.name}
                                                </td>

                                                <td className="action-column">
                                                    {user.email}
                                                </td>

                                               <td className="action-column">
                                                    <Badge
                                                        color={
                                                            user.role === "SuperAdmin" || user.role === "Admin"
                                                                ? "danger"
                                                                : user.role === "Coordinator"
                                                                    ? "primary"
                                                                    : "info"
                                                        }
                                                    >
                                                        {user.role}
                                                    </Badge>
                                                </td>
                                               <td className="action-column">
                                                    {user.gender}
                                                </td>
                                                <td className="action-column">
                                                    {user.phoneNumber}
                                                </td>
                                                <td className="action-column"> {formatTime(user.createdAt)}</td>
                                                <td className="action-column"> {formatDate(user.loginAt)}</td>

                                                <td className="action-column">
                                                    <Badge
                                                        color={user.isBlocked ? "danger" : "success"}
                                                    >
                                                        {user.isBlocked ? "Inactive" : "Active"}
                                                    </Badge>
                                                </td>

                                         <div className="action-buttons">
    <Button
        color="warning"
        size="sm"
        onClick={() => {
            setSelectedUser(user);
            setEditOpen(true);
        }}
    >
        <Pen fontSize="small" />
    </Button>

    <Button
        color="info"
        size="sm"
        onClick={() => {
            setSelectedUser(user);
            setPermissionOpen(true);
        }}
    >
        <ShieldBan fontSize="small" />
    </Button>

    <Button
        color="danger"
        size="sm"
        onClick={() => openDelete(user)}
    >
        <Trash2 size={16} />
    </Button>
</div>

                                            </tr>

                                        ))
                                    }

                                </tbody>

                            </Table>
                           
</div>

                    }
                     <div className="mobile-users">

    {paginateduser.map((user) => (

        <Card
            key={user.userID}
            className="mobile-user-card"
        >

            <CardBody>

                <div className="user-name">
                    {user.name}
                </div>

                <div><strong>Email :</strong> {user.email}</div>

                <div>
                    <strong>Role :</strong>

                    <Badge
                        className="ms-2"
                        color={
                            user.role === "SuperAdmin" || user.role === "Admin"
                                ? "danger"
                                : user.role === "Coordinator"
                                    ? "primary"
                                    : "info"
                        }
                    >
                        {user.role}
                    </Badge>
                </div>

                <div>
                    <strong>Gender :</strong> {user.gender}
                </div>

                <div>
                    <strong>Phone :</strong> {user.phoneNumber}
                </div>

                <div>
                    <strong>Created :</strong> {formatTime(user.createdAt)}
                </div>

                <div>
                    <strong>Last Login :</strong> {formatDate(user.loginAt)}
                </div>

                <div className="mt-2">

                    <Badge
                        color={user.isBlocked ? "danger" : "success"}
                    >
                        {user.isBlocked ? "Inactive" : "Active"}
                    </Badge>

                </div>

                <div className="mobile-actions">

                    <Button
                        color="warning"
                        size="sm"
                        onClick={() => {
                            setSelectedUser(user);
                            setEditOpen(true);
                        }}
                    >
                        <Pen size={16} />
                    </Button>

                    <Button
                        color="info"
                        size="sm"
                        onClick={() => {
                            setSelectedUser(user);
                            setPermissionOpen(true);
                        }}
                    >
                        <ShieldBan size={16} />
                    </Button>

                    <Button
                        color="danger"
                        size="sm"
                        onClick={() => openDelete(user)}
                    >
                        <Trash2 size={16} />
                    </Button>

                </div>

            </CardBody>

        </Card>

    ))}

</div>

                </CardBody>

            </Card>

            <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap">

                <div>
                    Showing{startIndex + 1}-{Math.min(endIndex, filteredUsers.length)} of {filteredUsers.length}
                </div>

                <Pagination>
                    <PaginationItem disabled= {currentPage ===1}>
                        <PaginationLink
                        previous
                         className="bg-primary text-white border-primary"
                        onClick={(e)=> {
                            e.preventDefault();
                            setCurrentPage((prev) => prev -1);
                        }}/>

                    </PaginationItem>
                    <PaginationItem disabled ={currentPage === totalPages}>
                        <PaginationLink
                        next
                         className="bg-primary text-white border-primary"
                        onClick={(e) => {
                            e.preventDefault();
                            setCurrentPage((prev)=> prev + 1);
                        }}
                        />
                    </PaginationItem>

                </Pagination>

            </div>

            {
                selectedUser &&

                <EditUserModal
                    isOpen={editOpen}
                    toggle={() => setEditOpen(false)}
                    user={selectedUser}
                    onSaved={loadUsers}
                />
            }

            {
                selectedUser &&

                <PermissionModal
                    isOpen={permissionOpen}
                    toggle={() => setPermissionOpen(false)}
                    user={selectedUser}
                    onSaved={loadUsers}
                />
            }
            {selectedUser && (
                <DeleteuserModal
                    isOpen={deteleuserOpen}
                    name={selectedUser.name}
                    toggle={() => setdeteleuserOpen(false)}
                    onDelete={deleteUser}
                    loading={deleting}
                />
            )}

            <CreateUserModal
                isOpen={createOpen}
                toggle={() => setCreateOpen(false)}
                onSaved={loadUsers}
            />
        </Container>

    );

};

export default UserManage;